import React, { useCallback, useEffect, useRef, useState } from 'react'
import './History.css'
import images1 from '../../assets/images1.jfif'
import { Checkbox, Col, Dropdown, Menu, Row} from 'antd'
import { useNavigate } from "react-router-dom";
import { AlignLeftOutlined, FilterOutlined, PrinterOutlined, UploadOutlined } from '@ant-design/icons'
import { BASE_URL, FetchDepartment, FetchDesignation, FetchStaff } from '../../utils/constant';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css'
import Filter from '../../assets/icons/filter-box.svg';
import { useSelector } from 'react-redux';
function History({setSales, onSalesDepartmentClick }) {
  const designationState = useSelector((state) => state.designation.designation);
  const departmentState = useSelector((state) => state.department.department);
    const [departments, setDepartments] = useState(departmentState);
  const [designations, setDesignations] = useState(designationState);
  const [selectedFilters, setSelectedFilters] = useState({
    designation: [],
    department: [],
  });
    const gridRef = useRef();
    const capitalizeFirstLetter = (str) => {
        return str?.replace(/\b\w/g, (char) => char.toUpperCase());
      };
    const navigate = useNavigate();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [staffData, setStaffData] = useState(null);
    const gridOptions ={
       
        onRowClicked: event => myFunction(event)
       } 
    
       const myFunction = (event) => {
        //    console.log('rowData:')
        //    console.log(event.data)
        //    navigate(`/salesdepartment/${event.data.item._id}`)
            // Call the callback function from Dashboard
            onSalesDepartmentClick(event.data.item._id);
            setSales('salesdepartment')
            const savedState = JSON.parse(sessionStorage.getItem("dashboardState")) || {};

            const stateToSave = {
              attendance:savedState.attendance,
              salesDepartmentId:savedState.salesDepartmentId,
              currentStaffId:savedState.currentStaffId,
              click : savedState.click,
              empClick:savedState.empClick,
              sales:'salesdepartment',
              currentStaff:savedState.currentStaff ,
              active:savedState.active ,
              salesDepartmentId:event.data.item._id ,
            };
            sessionStorage.setItem("dashboardState", JSON.stringify(stateToSave));
           
          
       }
    const handlesales = (sal) => {
        setSales(sal)
    };
    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
          'quickFilterText',
          document.getElementById('filter-text-box').value
        );
      }, []);
    useEffect(() => {
        getStaffList();
      }, [selectedFilters]);

      const getStaffList = async () =>{
        const filtersToSend = Object.fromEntries(
          Object.entries(selectedFilters).filter(([_, value]) => value.length > 0)
      );
        const token = localStorage.getItem('authToken');
      
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${FetchStaff}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify(
              filtersToSend
                ),
          });
          
          if (response.ok) {
            const data = await response.json();
            const activeStaff = data.data.filter(item => item.isActive);
            setStaffData(activeStaff)
            console.log('StaffToday',data)
            
          } else {
            const data = await response.json();
            console.log('stafTodayerr',data)
            // toast.error(data.errorMessage, {
            //   position: toast.POSITION.TOP_RIGHT,
            // });
            
          }
        };
       
        await fetchData();
       
      }
      const columnDefs = [{
        headerName: 'Profile',
        field:'profile',
        flex: 1,
        cellRenderer: (params) => {
            return(
            <>
          <div className='flex items-center'>
            <img
              className='w-[30px] h-[30px] rounded-full !mr-3'
              src={params.data?.item?.faceRegisterUrl || params.data?.item?.logo}
              alt=''
            />
            <p>{capitalizeFirstLetter(params.data.item?.firstName)} {capitalizeFirstLetter(params.data.item?.lastName)}</p>
          </div>
          </>
            )
            },
      },
      {
        headerName: 'Department/Designation',
        field:'dept',
        flex: 1,
        cellRenderer: (params) => {
            return(
            <>
          <div className=''>
            <Row>
             
              <Col sm={18} className='mt-1 d-flex'>
                <p>{capitalizeFirstLetter(params.data.item?.designation?.designationName)}</p>
                <p className='ml-1 mr-1'> | </p>
                <p>{capitalizeFirstLetter(params.data.item?.department?.departmentName)}</p>
              </Col>
            </Row>
          </div>
          </>
            )
            },
      },
      
      
    ];
      const data = staffData?.map((item, index) => {
      
       
        return {
          key: index,
          item: item,
          profile: item.firstName,
        };
      });
   
    // const data = [];
    // for (let i = 0; i < 46; i++) {
    //     data.push({
    //         key: i,
    //         name: `Edward King ${i}`,
    //         leave: 'Rule 2',
    //         atten: 'Rule 2',
    //         main: '30',
    //         payroll: 'Payroll',
    //         attendance: "Atten.Taker",
    //         shift: 'Gen-A'
    //     });
    // }
    const onSelectChange = (newSelectedRowKeys) => {
        console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    };
    // const rowSelection = {
    //     selectedRowKeys,
    //     onChange: onSelectChange,
    // };
    // const scroll = { y: 300 };
    useEffect(() => {
        // getDepartmentList();
        // getDesignationList();
      }, []);
      const getDesignationList = async () => {
        const token = localStorage.getItem("authToken");
    
        try {
          const fetchData = async () => {
            const response = await fetch(`${BASE_URL}/${FetchDesignation}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`,
              },
              body: JSON.stringify({isDeleted:false}),
            });
    
            if (response.ok) {
              const data = await response.json();
              const activeDesignation = data.data.filter((item) => item.isActive);
              const newArray = activeDesignation.map((item) => ({
                value: item.designationName,
                key: item.designationId,
              }));
              console.log("activeDesignation", newArray);
              setDesignations(newArray);
            } else {
              const data = await response.json();
              console.log("departmenterr", data);
            }
          };
          await fetchData();
        } catch (error) {
          console.error("Error updating designation:", error);
        }
      };
      const getDepartmentList = async () => {
        const token = localStorage.getItem("authToken");
    
        try {
          const fetchData = async () => {
            const response = await fetch(`${BASE_URL}/${FetchDepartment}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`,
              },
              body: JSON.stringify({isDeleted:false}),
            });
    
            if (response.ok) {
              const data = await response.json();
              const activeDepartment = data.data.filter((item) => item.isActive);
              const newArray = activeDepartment.map((item) => ({
                value: item.departmentName,
                key: item.departmentId,
              }));
              console.log("activeDepartment", newArray);
    
              setDepartments(newArray);
            } else {
              const data = await response.json();
              console.log("departmenterr", data);
            }
          };
          await fetchData();
        } catch (error) {
          console.error("Error updating designation:", error);
        }
      };
    const filters = {
        designation: designations,
        department: departments,
      };
    
      const handleFilterMenuClick = (type, { key }) => {
        const updatedSelection = selectedFilters[type].includes(key)
          ? selectedFilters[type].filter((item) => item !== key)
          : [...selectedFilters[type], key];
        console.log("selectedFilters", selectedFilters);
        setSelectedFilters({ ...selectedFilters, [type]: updatedSelection });
      };
    
    const filterMenu = (type) => (
        <Menu onClick={(item) => handleFilterMenuClick(type, item)}>
          {filters[type].map((filter) => (
            <Menu.Item className='checktext' key={filter.key}>
              <Checkbox className='mr-1' checked={selectedFilters[type].includes(filter.key)}/>
                {filter.value}
            </Menu.Item>
          ))}
        </Menu>
      );
    const dropdownMenu = (
        <Menu>
          <Menu.SubMenu key="designation" title="Designation">
            {filterMenu("designation")}
          </Menu.SubMenu>
          <Menu.SubMenu key="department" title="Department">
            {filterMenu("department")}
          </Menu.SubMenu>
        </Menu>
      );
    return (
        <div className='p-2'>
            {/* <Row>
                <Col sm={3} className='mr-1'>
                    <div className='history-first'>
                        <Row>
                            <Col sm={12}>
                                <p className='his-31'>31</p>
                                <p className='his-tot'>Total records</p>
                            </Col>
                            <Col sm={12} className='mt-1'>
                                <p className='his-per'>Permanent: 10</p>
                                <p className='his-per'>Contect: 21</p>

                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col sm={3} className='mr-1'>
                    <div className='history-first'>
                        <Row>
                            <Col sm={12}>
                                <p className='his-31'>5</p>
                                <p className='his-tot'>Deactivated</p>
                            </Col>
                            <Col sm={12} className='mt-1'>
                                <p className='his-per'>Permanent: 10</p>
                                <p className='his-per'>Contect: 21</p>

                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col sm={3} className='mr-1'>
                    <div className='history-first'>
                        <Row>
                            <Col sm={12}>
                                <p className='his-31'>10</p>
                                <p className='his-tot'>Faces missing</p>
                            </Col>
                            <Col sm={12} className='mt-1'>
                                <p className='his-per'>Permanent: 10</p>
                                <p className='his-per'>Contect: 21</p>

                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col sm={3} className='mr-1'>
                    <div className='history-first-stre'>
                        <Row>
                            <Col sm={12}>
                                <p className='his-31'>20</p>
                                <p className='his-tot'>STREAM user</p>
                            </Col>
                            <Col sm={12}>
                                <p className='his-per'>Permanent: 10</p>
                                <p className='his-per'>Contect: 21</p>
                                <p className='his-per'>No Access: 11</p>


                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row> */}
            <Row className='mt-3'>
                <Col sm={10}>
                    <div className='flex justify-between'>
                        {/* <PrinterOutlined className='history-icon' /> */}
                        <input
                            type="text"
                            id="filter-text-box"
                            placeholder="Search..."
                            className='h-[39px] border-[2px] border-[#99ACBF] rounded-lg !px-4 text-sm mr-3 w-44'
                            onInput={onFilterTextBoxChanged}
                          />
                        <div>
                        <Dropdown
                overlay={dropdownMenu}
                trigger={["click"]}
                placement="bottom"
              >
                {/* <Button className="btn filterBtn">Filter</Button> */}
                            <img src={Filter} className='cursor-pointer'/>
              </Dropdown>
                            {/* <AlignLeftOutlined className='history-icon mr-1' />
                            <UploadOutlined className='history-icon mr-3' /> */}
                        </div>
                    </div>

                    {/* <div className='mt-2'>
                        <p className='his-sal-title'>Sales Department</p>
                    </div> */}
                    <div className='ag-theme-alpine text-base border-none font-proxima tableBordered' style={{  marginTop: '10px' }}>
                    <AgGridReact
       ref={gridRef}
        columnDefs={columnDefs}
        rowData={data}
        gridOptions={gridOptions}
        domLayout='autoHeight'
        // onGridReady={(params) => setGridApi(params.api)}
        pagination={true}
        getRowHeight={() => 60}
        paginationPageSize={20}
        paginationPageSizeSelector={false}
      />
                    </div>
                    {/* <div className='flex justify-between sal-pro-back mt-2'>
                        <div>
                            <Row>
                                <Col sm={5}>
                                    <img className="fineimage" style={{ width: "30px", height: "25px" }} src={images1} alt="" />

                                </Col>
                                <Col sm={19}>
                                    <p style={{ fontSize: "13px", fontWeight: "bold", marginTop: '5px', marginLeft: '3px' }}>Bhaskar Sharma</p>
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <p className='sal-con-pro-his'>Sales Manager | Sales Dept.</p>
                        </div>
                    </div>
                    <div className='flex justify-between sal-pro-back mt-2'>
                        <div>
                            <Row>
                                <Col sm={5}>
                                    <img className="fineimage" style={{ width: "30px", height: "25px" }} src={images1} alt="" />

                                </Col>
                                <Col sm={19}>
                                    <p style={{ fontSize: "13px", fontWeight: "bold", marginTop: '5px', marginLeft: '3px' }}>Bhaskar Sharma</p>
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <p className='sal-con-pro-his'>Sales Manager | Sales Dept.</p>
                        </div>
                    </div>
                    <div className='flex justify-between sal-pro-back mt-2'>
                        <div>
                            <Row>
                                <Col sm={5}>
                                    <img className="fineimage" style={{ width: "30px", height: "25px" }} src={images1} alt="" />

                                </Col>
                                <Col sm={19}>
                                    <p style={{ fontSize: "13px", fontWeight: "bold", marginTop: '5px', marginLeft: '3px' }}>Bhaskar Sharma</p>
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <p className='sal-con-pro-his'>Sales Manager | Sales Dept.</p>
                        </div>
                    </div>
                    <div className='mt-2'>
                        <p className='his-sal-title'>Engineering Department</p>
                    </div>
                    <div className='flex justify-between sal-pro-back'>
                        <div>
                            <Row>
                                <Col sm={5}>
                                    <img className="fineimage" style={{ width: "30px", height: "25px" }} src={images1} alt="" />

                                </Col>
                                <Col sm={19}>
                                    <p style={{ fontSize: "13px", fontWeight: "bold", marginTop: '5px', marginLeft: '3px' }}>Bhaskar Sharma</p>
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <p className='sal-con-pro-his'>Sales Manager | Sales Dept.</p>
                        </div>
                    </div>
                    <div className='flex justify-between sal-pro-back mt-2'>
                        <div>
                            <Row>
                                <Col sm={5}>
                                    <img className="fineimage" style={{ width: "30px", height: "25px" }} src={images1} alt="" />

                                </Col>
                                <Col sm={19}>
                                    <p style={{ fontSize: "13px", fontWeight: "bold", marginTop: '5px', marginLeft: '3px' }}>Bhaskar Sharma</p>
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <p className='sal-con-pro-his'>Sales Manager | Sales Dept.</p>
                        </div>
                    </div>
                    <div className='flex justify-between sal-pro-back mt-2'>
                        <div>
                            <Row>
                                <Col sm={5}>
                                    <img className="fineimage" style={{ width: "30px", height: "25px" }} src={images1} alt="" />

                                </Col>
                                <Col sm={19}>
                                    <p style={{ fontSize: "13px", fontWeight: "bold", marginTop: '5px', marginLeft: '3px' }}>Bhaskar Sharma</p>
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <p className='sal-con-pro-his'>Sales Manager | Sales Dept.</p>
                        </div>
                    </div>
                    <div className='flex justify-between sal-pro-back mt-2'>
                        <div>
                            <Row>
                                <Col sm={5}>
                                    <img className="fineimage" style={{ width: "30px", height: "25px" }} src={images1} alt="" />

                                </Col>
                                <Col sm={19}>
                                    <p style={{ fontSize: "13px", fontWeight: "bold", marginTop: '5px', marginLeft: '3px' }}>Bhaskar Sharma</p>
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <p className='sal-con-pro-his'>Sales Manager | Sales Dept.</p>
                        </div>
                    </div> */}
                </Col>
            </Row>
        </div>
    )
}

export default History